import { Tooltip } from '@/components/ui/tooltip';
import { Badge } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { ProgramStatus } from '@fluenceur/types';

interface ProgramCardStatusBadgeProps {
  status: ProgramStatus;
  /**
   * The switch to the free plan paused it. Said apart from a programme paused
   * by hand, so the brand finds in the list the state the plan put it in.
   */
  pausedByPlan?: boolean;
}

/** Small uppercase status pill shown at the top of a program card. */
const ProgramCardStatusBadge = ({ status, pausedByPlan = false }: ProgramCardStatusBadgeProps) => {
  const { t } = useTranslation();
  const isActive = status === ProgramStatus.Active;
  const label = isActive
    ? t('programs.browse.status.active')
    : pausedByPlan
      ? t('programs.browse.status.pausedByPlan')
      : t('programs.browse.status.inactive');

  return (
    <Tooltip
      content={t('programs.browse.status.pausedByPlanHint')}
      disabled={isActive || !pausedByPlan}
      showArrow
    >
      <Badge
        colorPalette={isActive ? 'green' : 'gray'}
        tabIndex={!isActive && pausedByPlan ? 0 : undefined}
      >
        {label}
      </Badge>
    </Tooltip>
  );
};

export default ProgramCardStatusBadge;
